/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftStatusMutationRequest, PostApiBarberShiftStatusMutationResponse, PostApiBarberShiftStatus400, PostApiBarberShiftStatus401, PostApiBarberShiftStatus403, PostApiBarberShiftStatus404, PostApiBarberShiftStatus500 } from "../entities/PostApiBarberShiftStatus";

function getPostApiBarberShiftStatusUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/status` as const }
  return res
}

/**
 * @description Изменение статуса (свободен/занят/перерыв)
 * @summary Изменить статус мастера
 * {@link /api/barber/shift/status}
 */
export async function postApiBarberShiftStatus(data: PostApiBarberShiftStatusMutationRequest, config: Partial<RequestConfig<PostApiBarberShiftStatusMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, PostApiBarberShiftStatusMutationRequest>({ method : "POST", url : getPostApiBarberShiftStatusUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}